export enum LocalStorageKey {
  Onboarding = '@@helpful:Onboarding',
}
